import React from "react";
import { observer, inject } from "mobx-react";
import "./ObSummary.scss";
import ObSummaryStore from "./ObSummaryStore";
import Loader from "../../shared/Loader/Loader";
import Widget from "../Widget";
import Tile from "./Tile";
import className from "../../shared/className";
import {
  OB_SUMMARY_TILE_KEYS,
  OB_SUMMARY_TILE_ORDER,
  OB_SUMMARY_TILE_LABELS,
} from "./ObSummaryConstants";
import { MODULE_ID } from "../../shared/moduleIds";
import ErrorBoundary from "../../shared/ErrorBoundary";

class ObSummary extends Widget {
  constructor(props) {
    sessionStorage.moduleId = MODULE_ID.OBSTETRICS;
    super(props);
    this.store = new ObSummaryStore();
    this.props.store.hideMainNav = true;
  }

  componentDidMount() {
    this.store.fetchObSummary({
      asmpid: this.asmpid || this.props?.patient?.asmpid,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.patient?.asmpid !== this.props?.patient?.asmpid) {
      //We've changed patients so wipe the current waveform for a new one
      this.store.liveMode = true;
      this.store.fetchObSummary({
        asmpid: this.props?.patient?.asmpid,
      });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.store.liveMode = false;
    this.store.dispose();
  }

  render() {
    return (
      <div
        {...className({
          "ob-summary": true,
          widget: true,
          expanded: this.store.expandedTile,
        })}
      >
        <ErrorBoundary>
          {!this.store || this.store.loading ? (
            <Loader />
          ) : (
            <div className="container">
              {this.store.waveform ? (
                <Tile
                  tileType={OB_SUMMARY_TILE_KEYS.WAVEFORM}
                  model={this.store.waveform}
                  onClick={(e) => e.stopPropagation()}
                  summaryStore={this.store}
                  expanded={
                    this.store.expandedTile === OB_SUMMARY_TILE_KEYS.WAVEFORM
                  }
                  patient={this.props.patient || this.props.store.patient}
                  liveMode={this.store.liveMode}
                  toggleLiveMode={(e) => this.toggleLiveMode(e)}
                  parent={this}
                />
              ) : null}
              {this.store.expandedTile &&
              this.store.tiles[this.store.expandedTile] ? (
                <div className="expanded-tile">
                  <Tile
                    key={this.store.expandedTile}
                    tileType={this.store.expandedTile}
                    title={OB_SUMMARY_TILE_LABELS[this.store.expandedTile]}
                    model={this.store.tiles[this.store.expandedTile].model}
                    onClick={(e) => this.onClick(e, this.store.expandedTile)}
                    expanded={
                      this.store.expandedTile === this.store.expandedTile
                    }
                    summaryStore={this.store}
                    history={this.props.history}
                  />
                </div>
              ) : (
                <div className="detail-tiles">
                  <div className="upper-tile">
                    {this.store.tiles[OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS] ? (
                      <Tile
                        key={OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS}
                        tileType={OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS}
                        title={
                          OB_SUMMARY_TILE_LABELS[
                            OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS
                          ]
                        }
                        model={
                          this.store.tiles[OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS]
                            .model
                        }
                        onClick={(e) =>
                          this.onClick(e, OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS)
                        }
                        expanded={
                          this.store.expandedTile ===
                          OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS
                        }
                        summaryStore={this.store}
                        history={this.props.history}
                      />
                    ) : null}
                  </div>
                  <div className="lower-tiles">
                    {OB_SUMMARY_TILE_ORDER.slice(1).map((key) =>
                      this.store.tiles[key] ? (
                        <Tile
                          key={key}
                          tileType={key}
                          title={OB_SUMMARY_TILE_LABELS[key]}
                          model={this.store.tiles[key].model}
                          onClick={(e) => this.onClick(e, key)}
                          expanded={this.store.expandedTile === key}
                          summaryStore={this.store}
                          history={this.props.history}
                        />
                      ) : null,
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </ErrorBoundary>
      </div>
    );
  }

  onClick(e, key) {
    e && e.stopPropagation();
    this.store.expandedTile = this.store.expandedTile === key ? null : key;
  }
  toggleLiveMode(e) {
    e && e.preventDefault();
    this.store.liveMode = !this.store.liveMode;
  }
  get isInsideMultiview() {
    return !!this.props.patient;
  }
}

export default inject("store")(observer(ObSummary));
